import { render, staticRenderFns } from "./stockNBComments.vue?vue&type=template&id=9f2191a8&"
import script from "./stockNBComments.vue?vue&type=script&lang=js&"
export * from "./stockNBComments.vue?vue&type=script&lang=js&"
import style0 from "./stockNBComments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports